import { useEffect, useState } from "react";

const ROTATION_INTERVAL_MS = 20000;

export const AnimatedHeaderTitle: React.FC = () => {
  const [showAltTitle, setShowAltTitle] = useState(false);
  const baseTitleClasses =
    "font-['Unbounded'] text-[19px] font-bold leading-none tracking-wider uppercase header-title-gradient";

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setShowAltTitle((prev) => !prev);
    }, ROTATION_INTERVAL_MS);

    return () => window.clearInterval(intervalId);
  }, []);

  return (
    <div
      className="relative whitespace-nowrap"
      style={
        {
          "--header-title-gradient-duration": `${ROTATION_INTERVAL_MS / 1000}s`,
        } as React.CSSProperties
      }
    >
      {/* Hidden spacer — keeps the container sized to the longest title */}
      <span className={`${baseTitleClasses} invisible`} aria-hidden="true">
        TILOS MARATON
      </span>
      <span
        className={`${baseTitleClasses} absolute top-0 left-0 transition-all duration-700 ${
          showAltTitle ? "opacity-0 -translate-y-1" : "opacity-100 translate-y-0"
        }`}
      >
        TILOS MARATON
      </span>
      <span
        className={`${baseTitleClasses} absolute top-0 left-0 transition-all duration-700 ${
          showAltTitle ? "opacity-100 translate-y-0" : "opacity-0 translate-y-1"
        }`}
      >
        TŐLED FÜGG
      </span>
    </div>
  );
};
